import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { CheckCircle } from 'lucide-react';

const MarkAttendance = () => {
  return (
    <div className="space-y-6">
      <Card>
        <CardContent className="p-6">
          <div className="text-center">
            <CheckCircle className="w-16 h-16 mx-auto mb-4 text-gray-400" />
            <h2 className="text-xl font-semibold mb-2">Mark Attendance</h2>
            <p className="text-gray-600">Attendance marking coming soon...</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default MarkAttendance;
